import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import { PreArrivalFormTabFooterStyled } from './PreArrivalFormTab.styles';

const PreArrivalFormTabFooter = () => {
  const {
    formState: { dirtyFields },
  } = useFormContext();
  const { t } = useTranslation();

  // should not consider the 'preview.' fields for the dirty check
  const isDirty =
    Object.keys(dirtyFields).filter((field) => field !== 'preview').length > 0;

  return (
    <PreArrivalFormTabFooterStyled>
      <hr />
      <Button
        type="submit"
        bsStyle="primary"
        disabled={!isDirty}
        data-testid="save-pre-arrival-form-button"
      >
        {t('pageAutomations.preArrivalForm.savePreArrivalForm')}
      </Button>
    </PreArrivalFormTabFooterStyled>
  );
};

export default PreArrivalFormTabFooter;
